import { render, staticRenderFns } from "./ProjectItem.vue?vue&type=template&id=db04edac&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectItem.vue?vue&type=style&index=0&id=db04edac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db04edac",
  null
  
)

export default component.exports